<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      :customSub="true"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        oilCardTypeOptions: [],
        operationTypeOptions: [],
        form: [
          { // 主卡类型
            label: '主卡类型',
            value: 'oilCardType',
            type: 'select',
            default: -1,
            placeholder: '请输入主卡类型',
          },
          { // 主卡卡号
            label: '主卡卡号',
            value: 'oilCardNum',
            type: 'input',
            placeholder: '请输入主卡卡号',
          },
          { // 操作类型
            label: '操作类型',
            value: 'operationType',
            type: 'select',
            default: -1,
            placeholder: '请输入操作类型',
            options: [
              { label: '全部', value: -1 },
              { label: '分配', value: 1 },
              { label: '充值', value: 2 },
            ],
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      const oilCardNum = this.$route.query.oilCardNum;
      if (oilCardNum) {
        this.$refs.searchBox.setVal('oilCardNum', oilCardNum);
        searchBoxData.oilCardNum = oilCardNum;
      }
      this.$refs.tableBox.saveSearchBoxData({
        cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        ...searchBoxData,
      });
    },
    async getEnumList () {
      const enumList = await getEnumList({
        codeType: 'SERV_OIL_CARD_TYPE,SERV_GAS_CARD_TYPE',
      });
      if (enumList && enumList.length) {
        this.searchBoxData.oilCardTypeOptions = this.$route.path.includes('gasCard') ? [
          { label: '全部', value: -1 },
          ...enumList[1],
        ] : [
          { label: '全部', value: -1 },
          ...enumList[0],
        ];
      }
    },
  },
  async created () {
    this.getEnumList();
  },
};
</script>

<style lang="scss" scoped>
</style>
